export const NEW_INPUT = 'NEW_INPUT';
export const CHANGE_LOGIC = 'CHANGE_LOGIC';
export const CHANGE_THEME = 'CHANGE_THEME';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';



// WEBPACK FOOTER //
// ./src/actionTypes.js